import { render, staticRenderFns } from "./TcCalendar.vue?vue&type=template&id=3f1c7a7d&"
import script from "./TcCalendar.vue?vue&type=script&lang=js&"
export * from "./TcCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f1c7a7d')) {
      api.createRecord('3f1c7a7d', component.options)
    } else {
      api.reload('3f1c7a7d', component.options)
    }
    module.hot.accept("./TcCalendar.vue?vue&type=template&id=3f1c7a7d&", function () {
      api.rerender('3f1c7a7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcCalendar.vue"
export default component.exports